var pricesTableSetup = function (init) {
    $ajaxload = $('#pricestable');
    var operators = $ajaxload.data('operators');

    new tableScroll('.js-pricestable');
    new pricesTablePopups(operators);

    $('.js-pricestableanchor').click(function () {
        if (!$('ul.tabs#tabstop li.about a').hasClass('active') && !$('ul.tabs.tabsbottom li.about a').hasClass('active')) {
            ScrollToDivActive = false;
            $('ul.tabs#tabstop li.about a').click();
        }

        ScrollToDivActive = true;

        new scrollToDiv($('#pricestable-top'));
    });

    // Change Dates
    var dateFormat = "yy-m-d";

    dp = $("#changedates")

    exDates = eval(dp.data('exdates'));

    dp.datepicker({
        showOn: 'both',
        buttonText: "Change Dates",
        dateFormat: dateFormat,
        numberOfMonths: 1,
        minDate: 0,
        maxDate: "+1Y",
        beforeShowDay: excludeDates
    }).on("change", function () {
        new pricesTableUpdate(operators);
    }).datepicker('setDate', getMinDate());

    var startdate = new Date(formatDateISO(dp.val()));

    $('.js-weekarrows').click(function (e) {
        e.preventDefault();

        var d = new Date(formatDateISO(dp.val()));
        var days = ($(this).data('days') == '+' ? +7 : -7);
        d.setDate(d.getDate() + days);

        dp.val(formatDate((d < startdate ? startdate : d)));
        new pricesTableUpdate(operators);
    });

    if (init == 1) {
        new pricesTableUpdate(operators);
    }
};

var pricesTableUpdate = function (operators) {
    $('ul.buttondates').addClass('loading');

    var url = 'operators=' + dp.data('operators') + '&itemid=' + dp.data('itemid') + '&itemoptionid=' + dp.data('itemoptionid') + '&affiliate=' + dp.data('affiliate') + '&date=' + dp.val();

    $.ajax({
        type: 'GET',
        url: '/inc/display_itemprices.php',
        data: url,
        success: function (response) {
            $ajaxload.html(response);
            $('ul.buttondates').removeClass('loading');

            new tableScroll('.js-pricestable');
            new pricesTablePopups(operators);
        }
    });
};

var pricesTablePopups = function (operators) {
    // Price Popup
    if (operators == 1) {
        $('.js-pricestable td.spacesoperators a').click(function () {
            var td = $(this).parent();

            if (dynamicrequest) {
                dynamicrequest.abort();
            }

            var current = td.find('span').text();

            dynamicrequest = $.ajax({
                type: 'GET',
                url: "/operators/prices-availability/?ajax=1&date=" + td.data('date') + '&itemid=' + td.data('itemid') + '&time=' + td.data('time') + '&paxperday=' + td.data('paxperday') + '&current=' + current + '&sign=' + $(this).data('sign'),
                success: function (response) {
                    //if ((current == 1 && response == 0) || (current == 0 && response == 1)) {
                    new pricesTableUpdate(operators);
                    //} else {
                    //    td.find('span').text(response);
                    //}

                    dynamicrequest = null;
                }
            });
        });

        $('.js-pricestable td').not('.outofdaterange,.spacesoperators').each(function () {
            var td = $(this);
            td.click(function () {
                window.fancybox.open({
                    src: '/operators/prices-specials/?popup=1&edit=1&date=' + td.data('date') + '&time_key=' + td.data('key'),
                    type: 'iframe',
                    transitionEffect: false,
                    animationEffect: false,
                    afterClose: function () {
                        new pricesTableUpdate(operators);
                    }
                });
            });
        });
    } else {
        $('.js-pricestable td').not('.soldout').each(function () {
            var td = $(this);
            td.click(function () {
                url = window.location.pathname.replace(/\/$/, '').replace('/preview', '');
                url += '/book/?setdate=1&date=' + td.data('date') + '&spaces=' + td.data('spaces') + '&time_only=' + td.data('key')

                if (affiliate) {
                    window.location.href = url;
                } else {
                    window.fancybox.open({
                        src: url + '&popup=1',
                        type: 'iframe',
                        transitionEffect: false,
                        animationEffect: false
                    });
                }
            });
        });
    }
}
